<template>
	<div>
		<div class="mb-3 image-upload-buttons">
			<label class="btn btn-outline-warning me-2" @click="mobilePicture(true)">
				<i class="bi bi-camera"></i> Take Picture
			</label>
			<label class="btn btn-outline-orange" @click="mobilePicture(false)">
				<i class="bi bi-upload"></i> Upload Image
			</label>
		</div>
	</div>
</template>

<script setup>
	import { ref, onBeforeUnmount } from "vue"
	// import { Capacitor } from "@capacitor/core"
	import { InAppCamera } from "@/plugins/InAppCamera"
	import {
		Camera,
		// CameraDirection,
		CameraResultType,
		CameraSource,
	} from "@capacitor/camera"
	// import resizeImage from "@/utils/resizeImage"
	import Swal from "sweetalert2"

	const emits = defineEmits(["update:modelValue"])
	const props = defineProps({
		saveState: { type: Function },
	})

	// Image data
	const imagePreview = ref(null)
	// const image = ref(null)

	const disable = ref(false)

	async function mobilePicture(useCamera) {
		if (disable.value) return

		let img = null
		disable.value = true
		try {
			if (useCamera) {
				const camera = await InAppCamera.open({
					quality: 100,
					facing: "environment",
				})

				// if (imagePreview.value) {
				// 	URL.revokeObjectURL(imagePreview.value)
				// }

				imagePreview.value = camera.dataUrl
			} else {
				img = await Camera.getPhoto({
					quality: 100,
					width: 600,
					allowEditing: false,
					resultType: CameraResultType.DataUrl,
					source: CameraSource.Photos,
				})
				// if (imagePreview.value) {
				// 	URL.revokeObjectURL(imagePreview.value)
				// }
				imagePreview.value = img.dataUrl
			}
		} catch (e) {
			// Output error to console and show in SweetAlert
			console.log("Camera/Photos error:", e)
			//if user cancelled ignore
			if (!e.message.toLowerCase().includes("cancelled")) {
				Swal.fire({
					icon: "error",
					title: "Camera Error",
					text:
						e.message ||
						"An error occurred while accessing the camera or photos",
				})
			}
		}
		disable.value = false
		emits("update:modelValue", imagePreview.value)

		// if (props.saveState) {
		// 	await props.saveState()
		// }
		// let img = null
		// try {
		// 	img = await Camera.getPhoto({
		// 		quality: 100,
		// 		allowEditing: false,
		// 		resultType: CameraResultType.DataUrl,
		// 		width: 600,
		// 		source: useCamera ? CameraSource.Camera : CameraSource.Photos,
		// 		direction: CameraDirection.Rear,
		// 	})
		// 	// 	alert("IN HERE")
		// } catch (e) {
		// 	// Output error to console and show in SweetAlert
		// 	console.log("Camera/Photos error:", e)
		// 	Swal.fire({
		// 		icon: "error",
		// 		title: "Camera Error",
		// 		text:
		// 			e.message || "An error occurred while accessing the camera or photos",
		// 	})
		// }
		// if (img) {
		// 	imagePreview.value = img.dataUrl
		// 	// Convert dataUrl to blob for further usage
		// 	// const res = await fetch(img.dataUrl)
		// 	// const blob = await res.blob()
		// 	// image.value = blob
		// } else {
		// 	// image.value = null
		// 	imagePreview.value = null
		// }
		// emits("update:modelValue", imagePreview.value)
	}

	onBeforeUnmount(() => {
		if (imagePreview.value) {
			// URL.revokeObjectURL(imagePreview.value)
			imagePreview.value = null
		}
	})
</script>

<style lang="less" scoped>
	@import "../assets/colors.less";

	.btn-outline-orange {
		border-color: @color4;
		color: @color4;
	}

	.image-upload-buttons {
		display: flex;
		justify-content: start;
		gap: 1rem;
		.btn {
			position: relative;
			i {
				margin-right: 8px;
			}
		}
		input[type="file"] {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			opacity: 0;
			cursor: pointer;
		}
	}
</style>
